import { AREA_OF_EMPLOYMENT_SOURCE as AREA_OF_EMPLOYMENT_VALUES } from '@sravni/creditselection-customer-utils/lib/utils/customers';

import type { TCreditFormCommonFields, TCreditFormDictionaries } from 'entities/creditForm';

export const findAreaOfEmploymentByOkved = (
  okved: string,
  areaOfEmploymentDictionary: TCreditFormDictionaries['areasOfEmployment'],
): TCreditFormCommonFields['areaOfEmployment'] => {
  if (!okved) {
    return;
  }

  const result = areaOfEmploymentDictionary.find((dictionaryItem) => {
    const { meta: okvedRange = '' } = dictionaryItem.data || {};
    const ranges = String(okvedRange)
      .split(/\s*,\s*/)
      .map((item) => item.split(/\s*-\s*/));
    return ranges.some(([from, to]) =>
      to === undefined
        ? /** для конкретных значений */
          okved.indexOf(from) === 0
        : /** для диапазонов */
          okved >= from && okved <= `${to}999`,
    );
  });

  return result || areaOfEmploymentDictionary.find(({ value }) => value === AREA_OF_EMPLOYMENT_VALUES.OTHER);
};
